export default function WorkstationDirective() {
  return {
    template: require('./workstation.html'),
    scope: {
      assessmentId: '=',
      customerId: '=',
      workstation: '=',
      deleteCallback: '&',
      tooltipAppendToSelector: '@',
    },
    controller: 'WorkstationController',
    controllerAs: 'workstationVM',
    bindToController: true,
    replace: true,
  };
}
